import {Component} from 'react'

class AdminDashboard extends Component {
  render() {
    return <h1>Admin Dashboard</h1>
  }
}

export default AdminDashboard
